import React, { FC } from 'react';
import { Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import {
  HamburgerIcon,
  ToiletIcon,
  WheelchairIcon,
  WifiHighIcon,
  CarIcon,
  CurrencyRubIcon,
} from '@fronton/icons-react';
import { iconBaseline, StoreConveniencesContainer } from './styles';

type Props = {
  className?: string;
};

const WIFI = 'Wi-Fi';

export const StoreConveniences: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <StoreConveniencesContainer data-qa="store-conveniences" className={className}>
      <div>
        <CarIcon color="text-primary" size="s" className={iconBaseline} />
        <Typography color="text-primary" variant="caption">
          {t('parking')}
        </Typography>
      </div>
      <div>
        <ToiletIcon color="text-primary" size="s" className={iconBaseline} />
        <Typography color="text-primary" variant="caption">
          {t('toilet')}
        </Typography>
      </div>
      <div>
        <WheelchairIcon color="text-primary" size="s" className={iconBaseline} />
        <Typography color="text-primary" variant="caption">
          {t('accessibleEnvironment')}
        </Typography>
      </div>
      <div>
        <HamburgerIcon color="text-primary" size="s" className={iconBaseline} />
        <Typography color="text-primary" variant="caption">
          {t('cafe')}
        </Typography>
      </div>
      <div>
        <WifiHighIcon color="text-primary" size="s" className={iconBaseline} />
        <Typography color="text-primary" variant="caption">
          {WIFI}
        </Typography>
      </div>
      <div>
        <CurrencyRubIcon color="text-primary" size="s" className={iconBaseline} />
        <Typography color="text-primary" variant="caption">
          {t('atm')}
        </Typography>
      </div>
    </StoreConveniencesContainer>
  );
};
